import React, { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { useNavigate } from "react-router-dom";

const AdminBonusSettings = () => {
  const [settings, setSettings] = useState({
    baseEarning: 10,
    bonusPerStreak: 50,
    minDeliveriesForBonus: 5,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBonusSettings = async () => {
      try {
        const docRef = doc(db, "app_settings", "bonus_config");
        const snapshot = await getDoc(docRef);
        if (snapshot.exists()) {
          setSettings(snapshot.data());
        }
      } catch (error) {
        console.error("Error fetching bonus config:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBonusSettings();
  }, []);

  const handleChange = (e) => {
    setSettings((prev) => ({
      ...prev,
      [e.target.name]: parseInt(e.target.value, 10),
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await setDoc(doc(db, "app_settings", "bonus_config"), settings);
      alert("✅ Bonus settings saved!");
    } catch (error) {
      console.error("Error saving bonus config:", error);
      alert("❌ Failed to save bonus settings.");
    }
    setSaving(false);
  };

  if (loading) return <div className="p-6">Loading bonus settings...</div>;

  return (
    <div className="p-6 max-w-xl mx-auto bg-white shadow rounded-lg">
      <button
        className="mb-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
        onClick={() => navigate('/admin/dashboard')}
      >
        ← Back to Dashboard
      </button>
      <h2 className="text-2xl font-bold text-green-700 mb-4">💰 Bonus & Earnings Settings</h2>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Base Earning per Delivery (₹)</label>
          <input
            type="number"
            name="baseEarning"
            value={settings.baseEarning}
            onChange={handleChange}
            className="w-full mt-1 px-3 py-2 border rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Bonus Amount per Streak (₹)</label>
          <input
            type="number"
            name="bonusPerStreak"
            value={settings.bonusPerStreak}
            onChange={handleChange}
            className="w-full mt-1 px-3 py-2 border rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Min Deliveries for Bonus</label>
          <input
            type="number"
            name="minDeliveriesForBonus"
            value={settings.minDeliveriesForBonus}
            onChange={handleChange}
            className="w-full mt-1 px-3 py-2 border rounded"
          />
        </div>

        <button
          onClick={handleSave}
          disabled={saving}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          {saving ? "Saving..." : "Save Settings"}
        </button>
      </div>
    </div>
  );
};

export default AdminBonusSettings; 